import React from 'react';
import Button from '@atlaskit/button';
import ModalDialog, {
	ModalHeader,
	ModalTitle,
	ModalBody,
	ModalFooter,
} from '@atlaskit/modal-dialog';
import { ViewTracker } from '@atlassian/jira-analytics-web-react';
import { ShortcutScope } from '@atlassian/jira-common-components-keyboard-shortcuts';
import { useIntl } from '@atlassian/jira-intl';

import { messages } from './messages';
import type { DeleteModalProps } from './types';

export const DeleteModal = ({ onDelete, onCancel }: DeleteModalProps) => {
	const { formatMessage } = useIntl();

	const headerMessage = formatMessage(messages.headerMessage);
	const contentMessage = formatMessage(messages.contentMessage);
	const confirmActionText = formatMessage(messages.confirmActionText);
	const cancelActionText = formatMessage(messages.cancelActionText);

	return (
		<>
			<ViewTracker />
			<ShortcutScope>
				<ModalDialog onClose={onCancel} width="small">
					<ModalHeader>
						<ModalTitle appearance="danger">{headerMessage}</ModalTitle>
					</ModalHeader>
					<ModalBody>{contentMessage}</ModalBody>

					<ModalFooter>
						<Button
							appearance="primary"
							onClick={onDelete}
							/* eslint-disable-next-line jira/integration/test-id-by-folder-structure */
							testId="issue.views.common.web-link-line-card-group.delete-modal.confirm-button"
							interactionName="auto-generated.issue.views.common.web-link-line-card-group.delete-modal.confirm-button.button"
						>
							{confirmActionText}
						</Button>
						<Button
							appearance="subtle-link"
							onClick={onCancel}
							/* eslint-disable-next-line jira/integration/test-id-by-folder-structure */
							testId="issue.views.common.web-link-line-card-group.delete-modal.cancel-button"
							interactionName="auto-generated.issue.views.common.web-link-line-card-group.delete-modal.cancel-button.button1"
						>
							{cancelActionText}
						</Button>
					</ModalFooter>
				</ModalDialog>
			</ShortcutScope>
		</>
	);
};

export default DeleteModal;
